module.exports = __webpack_public_path__ + "static/img/200123.a5d9e1b9.png";